import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {ComissionDetail} from "./comission-detail";

const ComissionDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/comissions');
    }

    return (
        <ComissionDetail id={id} onClose={onClose}/>
    )

});

export default ComissionDetailPage;